import React from "react";

export function GeneratePassword() {
    var length = 20,
        charset = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*-=+_`,
        retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    if (!/[!@#$%&*-=+_]/g.test(retVal) || !/^[A-Z]/.test(retVal) || !/\d+/g.test(retVal)) {
        retVal = GeneratePassword()
    }
    return retVal;
}

export function GenericErrorHandler({ reason, addToast, additionalErrorHandler }: {
    reason: any,
    addToast: (value: React.SetStateAction<{ message: string, color: "danger" | "success" | "info" | "warning" | "dark" }>) => void,
    additionalErrorHandler?: (reason?: any) => void
}
) {
    if (reason.code === "ERR_NETWORK") {
        addToast({ message: reason.message, color: "danger" })
    } else {
        if (reason.response.status === 401)
            localStorage.removeItem('token')
        try {
            if (additionalErrorHandler)
                additionalErrorHandler(reason);
            addToast({ message: reason.response.data.message, color: "danger" })
        } catch {
            addToast({ message: "Undefined Error", color: "danger" })
        }
    }
}

export function IsNullOrEmpty(str: string | null): boolean {
    return str === null || str === "";
}

export function RandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function hslToRgba(h: number, s: number, l: number, a: number): string {
    s /= 100;
    l /= 100;
  
    const k = (n: number) => (n + h / 30) % 12;
    const a2 = s * Math.min(l, 1 - l);
    const f = (n: number) =>
      l - a2 * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  
    const r = Math.round(255 * f(0));
    const g = Math.round(255 * f(8));
    const b = Math.round(255 * f(4));
  
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  
  export function generateDistinctRgbaColors(n: number, alpha: number = 0.2): string[] {
    const colors: string[] = [];
    const step = 360 / n;
    for (let i = 0; i < n; i++) {
      const hue = i * step; // bagi rata hue
      colors.push(hslToRgba(hue, 70, 50, alpha)); // saturasi 70%, lightness 50%
    }
    return colors;
  }
  